import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceSignUpFormsRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/sign-up-forms')({
  component: WorkspaceSignUpFormsRoute,
});
